// extracted by mini-css-extract-plugin
export default {"Content":"Consent_Content__MnEiO","Checkbox":"Consent_Checkbox__6wmCM","Checkboxes":"Consent_Checkboxes__Tg42V","CGUContent":"Consent_CGUContent__9ODD2"};